// extracted by mini-css-extract-plugin
module.exports = {"noPadding":"styles_noPadding__3PC42","footerCopyRight":"styles_footerCopyRight__1udQN","footerItem":"styles_footerItem__1hDg6"};